import { Flex } from '@ifood/pomodoro-components';
import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';
import { LayoutProps, SpaceProps, layout, space } from 'styled-system';

export const Content = styled.div<LayoutProps & SpaceProps>`
  background-color: ${tokens.colors.white};
  border-radius: ${tokens.radii.s};
  box-shadow: 0px 2px 6px rgba(62, 62, 62, 0.2);
  min-width: 185px;

  ${layout};
  ${space};
`;

export const Container = styled(Flex)`
  width: 100%;
`;
